import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetReverseGeocode,
	GetReverseGeocodeParams,
	GetReverseGeocodeResponse,
	ReverseGeocodeApiResponse,
} from 'domain/usecases/private/profile/get-reverse-geocode';

export class RemoteGetReverseGeocode implements GetReverseGeocode {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<ReverseGeocodeApiResponse>,
	) {}

	async get(params: GetReverseGeocodeParams): Promise<GetReverseGeocodeResponse> {
		const {signal, ...otherParams} = params;

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params: otherParams,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
			case HttpStatusCode.created:
			case HttpStatusCode.noContent: {
				const data = httpResponse.data;
				if (data && 'content' in data && data.content) {
					return data.content;
				}
				return data as GetReverseGeocodeResponse;
			}
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
